import {Request} from '@simpli/serialized-request'
import {IResource} from '@simpli/resource-collection/dist/types/IResource'

export class GithubUser implements IResource {
  idGithubUserPk: number = 0
  login: string | null = null
  avatarUrl: string | null = null
  url: string | null = null
  createdAt: Date | null = null
  updatedAt: Date | null = null

  get $id() {
    return this.idGithubUserPk
  }

  set $id(val) {
    this.idGithubUserPk = val
  }

  get $tag() {
    return String(this.$id)
  }

  /**
   * Deletes an instance of a given ID of GithubUser
   */
  async removeGithubUser() {
    return await Request.delete(`/client/github-user/${this.$id}`)
      .name('removeGithubUser')
      .asNumber()
      .getData()
  }
}
